import React from "react";

const HowItWorks = ({ stack, skill }) => {
  console.log(skill);
  return (
    <section className="py-3 hire-stacks container">
      <div>
        <h4 className="text-center font-subhead mb-2 underline">
          Our <span className="text-capitalise">{stack}</span> Developers
          Expertise
        </h4>
        <p className="text-center w-80 mx-auto font-sm">
          Our highly experienced{" "}
          <span className="text-capitalise">{stack}</span> programmers timely
          deliver mobility solutions suiting your specific project requirements.
          Our services are centered around optimally leveraging the robust
          website development framework to build scalable and secure websites
          for global clients.
        </p>
      </div>

      <div className="row justify-content-between text-center py-3">
        <div className="capability col-md-3 border rounded m-25 py-2">
          <div className="c-icon mb-1 text-white">
            <i className={`${skill[0].icon} vertical-middle`}></i>
          </div>
          <h5 className="font-normal font-weight-bolder">Maintenance Expert</h5>
          <p className="m-0 font-sm">
            Hire offshore <span className="text-capitalise">{stack}</span>{" "}
            programmers from us to keep your existing website in trend. Our
            experts are proficient to keep your website up to customer demands.
          </p>
        </div>
        <div className="capability col-md-3 border rounded m-25 py-2">
          <div className="c-icon mb-1 text-white">
            <i className={`${skill[0].icon} vertical-middle`}></i>
          </div>
          <h5 className="font-normal font-weight-bolder">Full Consultation</h5>
          <p className="m-0 font-sm">
            Got queries regarding your website! Don’t worry, our{" "}
            <span className="text-capitalise">{stack}</span>
            experts will help you with all your development and
            business-specific queries.
          </p>
        </div>
        <div className="capability col-md-3 border rounded m-25 py-2">
          <div className="c-icon mb-1 text-white">
            <i className={`${skill[0].icon} vertical-middle`}></i>
          </div>
          <h5 className="font-normal font-weight-bolder">
            Dedicated Developers
          </h5>
          <p className="m-0 font-sm">
            Hire <span className="text-capitalise">{stack}</span> programmers
            online who are expert in creating robust mobility solutions for our
            global clients in diverse industries.
          </p>
        </div>
      </div>

      <div className="my-1">
        <h4 className="text-center font-subhead mb-2 underline">
          Hiring <span className="text-capitalise">{stack}</span> Developers
        </h4>
        <p className="text-center w-80 mx-auto font-sm">
          Trainers are working hard to increase the supply of
          <span className="text-capitalise">{stack}</span> developers worldwide.
          However, the demand for them grows more quickly than local labor
          markets can satisfy. This means that companies should expect to have
          problems finding and hiring{" "}
          <span className="text-capitalise">{stack}</span> developers locally.{" "}
          <span className="text-capitalise">{stack}</span>
          developers should have some technical abilities and soft skills and
          part of finding the right candidate for a{" "}
          <span className="text-capitalise">{stack}</span> developer position
          involves finding someone with a solid{" "}
          <span className="text-capitalise">{stack}</span> mindset. Someone
          who’s in tune with <span className="text-capitalise">{stack}</span>{" "}
          capabilities and tools. Someone who understands how changes in those
          capabilities and tools affect the programming work.
        </p>
      </div>
      <div className="my-1">
        <h4 className="text-center font-subhead mb-2 underline">
          Hire <span className="text-capitalise">{stack}</span> Developers in 4
          easy steps
        </h4>
        <div className="steps d-flex justify-content-center wrap">
          <div className="step w-40 d-flex my-1 align-items-center">
            <div
              style={{ color: "#999999" }}
              className="font-subhead font-weight-bolder mr-1">
              01
            </div>
            <p className="m-0 text-capitalise font-sm">
              Create <span style={{ color: "#FAAA1E" }}>An Account</span> <br />{" "}
              with us and get started
            </p>
          </div>
          <div className="step w-40 d-flex my-1 align-items-center">
            <div
              style={{ color: "#999999" }}
              className="font-subhead font-weight-bolder mr-1">
              02
            </div>
            <p className="m-0 text-capitalise font-sm">
              Send us the{" "}
              <span style={{ color: "#FAAA1E" }}>details of the project</span>{" "}
              <br /> you're trying to build
            </p>
          </div>
          <div className="step w-40 d-flex my-1 align-items-center">
            <div
              style={{ color: "#999999" }}
              className="font-subhead font-weight-bolder mr-1">
              03
            </div>
            <p className="m-0 text-capitalise font-sm">
              We{" "}
              <span style={{ color: "#FAAA1E" }}>
                interview <span className="text-capitalise">{stack}</span>{" "}
                Developer
              </span>{" "}
              <br /> candidates for you
            </p>
          </div>
          <div className="step w-40 d-flex my-1 align-items-center">
            <div
              style={{ color: "#999999" }}
              className="font-subhead font-weight-bolder mr-1">
              04
            </div>
            <p className="m-0 text-capitalise font-sm">
              You{" "}
              <span style={{ color: "#FAAA1E" }}>
                hire your choice{" "}
                <span className="text-capitalise">{stack}</span> Developer
              </span>{" "}
              <br /> And we handle all the paperwork
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
